export const KITCHEN_PREP_SET_SELECTED_TAB = 'KITCHEN_PREP_SET_SELECTED_TAB';



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/settings/types.js